export default __webpack_public_path__ + "static/logos-sm-f52e376c3b72cb35d6d82da41a23f1ef.png";